const clientEnabled =
    typeof window === 'object' && window.location.search.indexOf('enable_route_logs') !== -1

export function enableRouteLogs() {
    return process.env.ENABLE_ROUTE_DEBUG_LOGS || clientEnabled
}
